/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useMemo, useEffect, useRef } from "react";
import HeaderLayout from "../../layouts/admin/HeaderLayout";
import FooterLayout from "../../layouts/admin/FooterLayout";
import MaterialDataGrid from "../../components/DataTable";
import { axiosInstance } from "../../utils/commonInstance";
import useDataFetching from "../../hooks/useDataFatching";
import { Box, IconButton, Input, Modal, Typography } from "@mui/material";
import { Edit, Eye, MoreHorizontal } from "feather-icons-react";
import { handleExportData } from "../../components/DataTable";
import { useForm, Controller } from "react-hook-form";
import { showToast } from "../../hooks/showToast";
import Multiselect from "multiselect-react-dropdown";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import * as XLSX from "xlsx";

import { AltRoute, Close, Download } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { addSerialNumber, changeArrayKeys, createHeaderMap, extractKeysFromArray, flattenObject1, flattenObjectForReportsPage, transformData } from "../../utils/commonFunction";
import { Speaker } from "feather-icons-react";

const fetchDataForPlatform = async (params, endpoint) => {
  //   return await axiosInstance.post(`web/${endpoint}`, { params });
};

const AttendanceFilter = ({ title, dynamiColumns, endPoint, columnOrder, excludeKeys, exportColumns, keyMapping, toggleFormFillrter, filterOption, isExport = false, data, ComonComponanatList }) => {
  const location = useLocation();
  const {
    state,
    columnFilters,
    setColumnFilters,
    setGlobalFilter,
    // pagination,
    // setPagination,
    // manualFetchData,
  } = useDataFetching(fetchDataForPlatform, endPoint, title);
  const [calculations, setCalculations] = useState(0);
  const [formState, setFormState] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  useEffect(() => {
    setFormState(false);
  }, [endPoint]);
  useEffect(() => {
    setIsView(false);
    setPreviousData({});
    setIsEdit(false);
    setFormState(false);
  }, [title]);
  const [modal, setModal] = useState({
    isOpen: false,
    headerContent: "",
    subHeaderContent: "",
    data: {},
    clicked: null,
    text: "",
  });

  const handlePreviewClick = (row) => {
    setModal((prevData) => ({
      ...prevData,
      isOpen: true,
      header: "Image Preview",
      data: row,
    }));
    // Add your edit logic here
  };

  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [previousData, setPreviousData] = useState({});
  useEffect(() => {
    setIsView(false);
    setPreviousData({});
    setIsEdit(false);
    setFormState(false);
  }, [title]);

  const handleViewClick = (row) => {
    setIsView(true);
    setPreviousData(row);
    setIsEdit(false);
    setFormState(true);
    // Add your view logic here
  };

  const handleClose = () => {
    setModal((prevData) => ({
      ...prevData,
      isOpen: false,
      header: "",
      data: {},
    }));
  };

  useEffect(() => {
    // Assuming OpenNewPagination is an object with properties pageIndex and pageSize
    const calculation = pagination.pageIndex * pagination.pageSize;
    // Set test to 0 if OpenNewPagination.pageIndex is 0, otherwise use the calculation
    setCalculations(calculation);
  }, [pagination.pageIndex, pagination.pageSize]);

  const dynamicColumns = useMemo(() => {
    const columns = [];
    // Add dynamic columns
    columns.push({
      header: "Sr. No.",
      Cell: ({ row }) => {
        const number = calculations + (row?.index + 1);
        const formattedNumber = number < 10 ? `0${number}` : number;
        return <div className="sr-no">{formattedNumber}</div>;
      },
      maxSize: 15,
      minSize: 10,
    });

    dynamiColumns?.forEach((col) => {
      if (col.accessorKey === "action") {
        // Customize the Cell renderer for the actions column
        columns.push({
          ...col,
          Cell: ({ row }) => (
            <div style={{ display: "flex" }}>
              <>
                <div onClick={() => handleViewClick(row?.original)} style={{ marginRight: "5px", cursor: "pointer" }}>
                  <Eye />
                </div>
              </>
            </div>
          ),
        });
      } else {
        columns.push(col);
      }
    });
    return columns;
  }, [dynamiColumns, calculations]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "max-content",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    height: "500px",
    overflow: "auto",
    "@media (max-width: 600px)": {
      width: "96%",
    },
  };

  const handleBackButton = () => {
    setIsView(false);
    setIsEdit(false);
    setFormState(false);
    setPreviousData({});
  };

  useEffect(() => {
    setPagination({ pageIndex: 0, pageSize: 10 });
  }, [endPoint, title]);

  const [fillter, setFillter] = useState({ selectFillter: "", search: "" });
  const [selectFilter, setSelectFilter] = useState(null);
  const [roleRightsData, setRoleRightsData] = useState([]);
  const [value, onChange] = useState([]);
  //   const [value, onChange] = useState([
  //     new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  //     new Date(),
  //   ]);
  const [guard_name, setGuardName] = useState("");
  const [exportReportName, setExportReportName] = useState("");
  const [request_type, SetRequestType] = useState("");
  //   const StartDate = moment(value[0]).format("YYYY-MM-DD");
  //   const EndDate = moment(value[1]).format("YYYY-MM-DD");
  const StartDate = value[0] ? moment(value[0]).format("YYYY-MM-DD") : "";
  const EndDate = value[1] ? moment(value[1]).format("YYYY-MM-DD") : "";
  const [resetKey, setResetKey] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({});

  const [gridData, setGridData] = useState({
    data: [],
    rowCount: 0,
    isError: false,
    isLoading: false,
    isRefetching: false,
  });

  const lastFetchRef = useRef("");
  const fetchData = async (force = false) => {
    const requestData = {};

    if (isFiltered) {
      if (guard_name) requestData.guard_name = guard_name;
      if (request_type) requestData.request_type = request_type;
      if (value[0] && value[1]) {
        requestData.from = StartDate;
        requestData.to = EndDate;
      }
    }

    const fetchKey = JSON.stringify({
      page: pagination.pageIndex,
      size: pagination.pageSize,
      endPoint,
      guard_name,
      request_type,
      StartDate,
      EndDate,
      isFiltered,
    });

    if (!force && lastFetchRef.current === fetchKey) return;
    lastFetchRef.current = fetchKey;

    try {
      setGridData((prev) => ({ ...prev, isLoading: true }));
      
      const url = `web/${endPoint}?limit=${pagination?.pageSize}&page=${pagination?.pageIndex + 1}`;

      const response = await axiosInstance.post(url, requestData);
      if (!response?.data?.error) {
        setGridData({
          data: response?.data?.data,
          rowCount: response.data.totalRecords || response.totalRecords,
          isError: false,
          isLoading: false,
          isRefetching: false,
        });
      } else {
        showToast(response?.data?.message, "error");
        setGridData((prev) => ({ ...prev, isError: true, isLoading: false }));
      }
    } catch (error) {
      showToast("Error fetching data", "error");
      setGridData((prev) => ({ ...prev, isError: true, isLoading: false }));
    }
  };

  const handleFilterSubmit = async () => {
    setIsFiltered(true);
    setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
  };
 
  const manualFetchData = () => {
    fetchData(true); 
  };

  useEffect(() => {
    fetchData();
  }, [pagination, endPoint]);

  const handleFilterReset = () => {
    setValue("guard_name", "");
    setValue("request_type", "");
    setGuardName("");
    SetRequestType("");
    onChange([]);
    setIsFiltered(false);
    setPagination({ pageIndex: 0, pageSize: 10 });
  };

  const handleCalendarClose = () => {
    setResetKey((prev) => prev + 1);
  };

  const formStateRef = useRef(false);
  useEffect(() => {
    if (formStateRef.current === true && formState === false) {
      fetchData();
    }
    formStateRef.current = formState;
  }, [formState]);

  return (
    <>
      <div className="main">
        <HeaderLayout title={title} />
        {!formState ? (
          <section class="user-listmain content web">
            <>
              <div>
                <div class="mb-4 row gy-2">
                  <div class="col-xxl-3 col-xl-4 col-sm-6">
                    <div className="form-group">
                      <Controller
                        name="guard_name"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control py-2 w-100"
                            {...field}
                            defaultValue={guard_name}
                            onChange={(e) => {
                              field.onChange(e);
                              setGuardName(e.target.value);
                            }}
                            placeholder="Security Guard (Guard Code)"
                            style={{ backgroundColor: "#f5f7fb" }}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div class="col-xxl-3 col-xl-4 col-sm-6">
                    <div className="form-group">
                      <Controller
                        name="request_type"
                        control={control}
                        render={({ field }) => (
                          <select
                            className="form-select py-2 w-100"
                            {...field}
                            defaultValue={request_type}
                            onChange={(e) => {
                              field.onChange(e);
                              SetRequestType(e.target.value);
                            }}
                            style={{ backgroundColor: "#f5f7fb" }}
                          >
                            <option value="" selected>
                              Request Type
                            </option>
                            <option value="Create Attendance">Create Attendance</option>
                            <option value="Update Existing Attendance">Update Existing Attendance</option>
                          </select>
                        )}
                      />
                    </div>
                  </div>
                  <div class="col-xxl-3 col-xl-4 col-sm-6">
                    <DateRangePicker
                      key={resetKey}
                      // key={location.pathname}
                      maxDate={new Date()}
                      disableClock
                      value={value}
                      onChange={onChange}
                      format={"dd/MM/y"}
                      clearIcon={null}
                      className="w-100"
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                      onCalendarClose={handleCalendarClose}
                    />
                  </div>
                  <div class="col-xxl-3 col-xl-12 col-sm-6 text-end">
                    <button onClick={handleFilterSubmit} class="btn btn-lg btn-primary px-3 h-100 me-2">
                      {" "}
                      Search
                    </button>

                    <button class="btn btn-lg btn-primary px-3 h-100 me-2" onClick={handleFilterReset} disabled={!guard_name && !exportReportName && !request_type && !(value[0] && value[1])}>
                      Clear
                    </button>

                    <button
                      class="btn btn-lg btn-primary px-3 h-100"
                      onClick={() => {
                        setFormState(true);
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <MaterialDataGrid
                key={location.pathname}
                columns={dynamicColumns}
                //   data={gridData.data?.data}
                data={gridData.data}
                rowCount={gridData.rowCount}
                isError={gridData.isError}
                handleColumnFilter={setColumnFilters}
                handlePagination={setPagination}
                initialState={{
                  columnFilters: columnFilters,
                  isLoading: gridData.isLoading,
                  pagination: pagination,
                  showAlertBanner: gridData.isError,
                  showProgressBars: gridData.isRefetching,
                  columnOrder: columnOrder ? columnOrder : [],
                }}
              />
            </>
          </section>
        ) : (
          <ComonComponanatList toggleFormFillrter={handleBackButton} manualFetchData={manualFetchData} clearState={setFormState} setGlobalFilter={setGlobalFilter} isView={isView} isEdit={isEdit} previousData={previousData} />
        )}
        <FooterLayout />
        <style jsx>
          {`
            .image-grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;
            }
            .image-item {
              text-align: center;
            }
            .row {
              display: flex;
              justify-content: space-between;
            }
            .col {
              flex: 1 0 45%;
              margin: 10px;
              text-align: center;
            }
          `}
        </style>
      </div>
    </>
  );
};

export default AttendanceFilter;
